<wl-partial-card [class.mb-3]="!!rendering?.fields?.spacingBottom?.value">
  <ng-container slot="content">
    <sc-placeholder
      name="card-content-block"
      [rendering]="rendering"
    ></sc-placeholder>
  </ng-container>
</wl-partial-card>
